import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="footer footer-center p-10 bg-base-300 text-base-content">
      <div>
        <div className="grid grid-flow-col gap-4">
          <Link to="/terms" className="link link-hover">Terms of Use</Link>
          <Link to="/privacy" className="link link-hover">Privacy Policy</Link>
          <Link to="/refunds" className="link link-hover">Refunds</Link>
          <Link to="/contact" className="link link-hover">Contact</Link>
          <Link to="/faq" className="link link-hover">FAQ</Link>
        </div>
        <p className="mt-4">A product of Pacifico Technologies Private Limited</p>
        <p className="mt-1">Copyright © 2025 - All rights reserved</p>
      </div>
    </footer>
  );
}; 